<template>
    <div>
        <el-card>
            <el-row>
                <el-col :span="24">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/KPI/Index' }">绩效管理</el-breadcrumb-item>
                        <el-breadcrumb-item>KPI审核</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <!-- 查询条件 -->
            <el-row>
                <el-col style="margin-right:6px;" :span="3">
                    <el-input size="small" clearable v-model="AddName" placeholder="请输入创建人"></el-input>
                </el-col>
                <el-col style="margin-right:6px;" :span="3">
                    <!-- <el-input size="small" clearable v-model="searchName" placeholder="请输入创建人"></el-input> -->
                    <el-select size="small" v-model="StatusJ" placeholder="请选择绩效计划审核状态">
                        <el-option label="已发送，待人资审核" value="1"></el-option>
                        <el-option label="人资已驳回，待修改" value="2"></el-option>
                        <el-option label="人资审核完毕" value="3"></el-option>
                        <el-option label="已发送，待数据中心审核" value="4"></el-option>
                        <el-option label="数据中心已驳回，待修改" value="5"></el-option>
                        <el-option label="CEO驳回" value="6"></el-option>
                    </el-select>
                </el-col>
                <el-col style="margin-right:6px;" :span="3">
                    <el-select size="small" v-model="ResultStatus" placeholder="请选择绩效结果审核状态">
                        <el-option label="未发送" value="0"></el-option>
                        <el-option label="已发送，待人资审核" value="1"></el-option>
                        <el-option label="人资已驳回，待修改" value="2"></el-option>
                        <el-option label="人资审核完毕" value="3"></el-option>
                        <el-option label="已发送，待数据中心审核" value="4"></el-option>
                        <el-option label="数据中心已驳回，待修改" value="5"></el-option>
                        <el-option label="CEO驳回" value="6"></el-option>
                    </el-select>
                    <!-- <el-input size="small" clearable v-model="searchName" placeholder="请输入创建人"></el-input> -->
                </el-col>
                <el-col style="margin-right:6px;" :span="3">
                    <el-select size="small" v-model="KPIType" placeholder="请选择周期类型" @change="selectKPIType">
                        <el-option label="月度" value="0"></el-option>
                        <el-option label="季度" value="1"></el-option>
                    </el-select>
                </el-col>
                <el-col :class="KPITypeValue==0?'show':'hidden'" :span="3">
                    <el-select size="small" v-model="PeriodMonth" placeholder="请选择月度">
                        <el-option v-for="item in monthList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-col>                
                <el-col :class="KPITypeValue==1?'show':'hidden'" :span="3">
                    <el-select size="small" v-model="PeriodJ" placeholder="请选择季度">
                        <el-option label="Q1" value="Q1"></el-option>
                        <el-option label="Q2" value="Q2"></el-option>
                        <el-option label="Q3" value="Q3"></el-option>
                        <el-option label="Q4" value="Q4"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="2">
                    <el-button icon="el-icon-search" size="small" @click="SearchByName"></el-button>
                </el-col>
                <el-col :span="1">
                    <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
                </el-col>
                <el-col v-if="currentRole.Key=='HR'" :span="1">
                    <el-button type="danger" size="small" @click="SendMessage" plain>KPI设置/评分消息发送</el-button>
                </el-col>
            </el-row>
            <!-- 审核KPI列表信息 -->
            <el-table border :data="AuditKPIList" style="width: 100%;margin-top:20px;" v-loading="loading" size="small">
                <el-table-column  min-width="10" label="类型">
                    <template slot-scope="scope">
                        {{scope.row.KpiType == 0 ? "月度" : "季度"}}
                    </template>
                </el-table-column>
                <el-table-column  min-width="10" :formatter="formatDate" label="年">
                     <!-- <template slot-scope="scope">
                        {{scope.row.createTime}}
                    </template> -->
                </el-table-column>
                <el-table-column  min-width="10" prop="Period" label="周期"></el-table-column>
                <el-table-column  min-width="10" prop="TrueName" label="创建人"></el-table-column>  
                <el-table-column  min-width="10" prop="MainDeptsName" label="部门"></el-table-column>            
                <el-table-column  min-width="10" label="绩效计划审核状态">
                    <template slot-scope="scope">
                        {{scope.row.Status == 1 ? "已发送，待人资审核" : (scope.row.Status == 4 ? "已发送，待数据中心审核" : (scope.row.Status == 2 ? "人资已驳回，待修改" : (scope.row.Status == 5 ? "数据中心已驳回，待修改" : (scope.row.Status == 6 ? "CEO驳回" : "人资审核完毕"))))}}
                    </template>
                </el-table-column>
                <el-table-column  min-width="10" label="绩效结果审核状态">
                    <template slot-scope="scope">
                        {{scope.row.ResultStatus == 1 ? "已发送，待人资审核" : (scope.row.ResultStatus == 4 ? "已发送，待数据中心审核" : (scope.row.ResultStatus == 2 ? "人资已驳回，待修改" : (scope.row.ResultStatus == 5 ? "数据中心已驳回，待修改" : (scope.row.ResultStatus == 6 ? "CEO驳回" : (scope.row.ResultStatus == 0 ? "未发送":"人资审核完毕")))))}}
                    </template>
                </el-table-column>
                <el-table-column  min-width="10" prop="BecauseOf" label="驳回原因"></el-table-column>
                <el-table-column  min-width="10" label="操作"  fixed="right" :span="8">
                    <template slot-scope="scope" >
                        <el-button type="text" @click='bindKPI(scope.row)'>查看</el-button>
                        <el-button type="text" @click='bindKPISet(scope.row)'>查看设置</el-button>

                        <!-- 带条件的显示 -->
                        <!-- CEO驳回 -->
                        <el-button type="text" v-if="currentRole.Key=='CEO'&&scope.row.Status==1" @click="initEditStatus(scope.row,'-1')">CEO驳回</el-button>

                        <!-- HR或数据中心绩效计划驳回或完成 -->
                        <el-button type="text" v-if="(currentRole.Key=='HR'&&scope.row.Status==1)||(currentRole.Key=='IDC'&&scope.row.Status==4)" @click="initEditKpi(scope.row,'0')">计划驳回</el-button>
                        <el-button type="text" v-if="(currentRole.Key=='HR'&&scope.row.Status==1)||(currentRole.Key=='IDC'&&scope.row.Status==4)" @click="initEditKpiInfo(scope.row,'3')">计划完成</el-button>

                        <!-- HR或数据中心绩效结果驳回或完成 -->
                        <el-button type="text" v-if="scope.row.Status == 3 && ((scope.row.ResultStatus == 1 && currentRole.Key == 'HR') || (scope.row.ResultStatus == 4 && currentRole.Key == 'IDC'))" @click="initEditKpi(scope.row,'1')">驳回结果</el-button>
                        <el-button type="text" v-if="scope.row.Status == 3 && ((scope.row.ResultStatus == 1 && currentRole.Key == 'HR') || (scope.row.ResultStatus == 4 && currentRole.Key == 'IDC'))" @click="initEditResult(scope.row,'3')">完成结果</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页数据列表 -->
            <el-row>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="pageSizes"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    style="float:right"
                ></el-pagination>
            </el-row>


            <el-dialog width="70%" :title="dialagTitle" :visible.sync="dialogVisible">
                <el-row>
                    <el-input type="textarea"  :rows="2" v-model="becauseOf" placeholder="请输入驳回原因"></el-input>
                </el-row>
                <el-row style="margin-top:20px;">
                    <!-- <span slot="footer" class="dialog-footer"> -->
                        <el-button type="primary" @click="tijiao">驳回</el-button>
                    <!-- </span> -->
                </el-row>
            </el-dialog>
        </el-card>
    </div>
</template>
<script>
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic"; 
import { GetCurrentUserInfo } from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { AuditkpiList,UpdateStatus,UpdateKPIStatus,SendMessage } from "../../until/ZeusApiSDK/Logic/KPILogic";
export default {
    data(){
        return{
            currentUser:{},//当前用户
            currentRole:{},//当前用户角色
            AddName:'',//条件搜索，创建人姓名
            StatusJ:'',//请选择绩效计划审核状态
            ResultStatus:'',//请选择绩效结果审核状态
            KPIType:'',//请选择周期类型
            PeriodMonth:'',//请选择月度
            PeriodJ:'',//请选择季度
            KPITypeValue:'',//判断显示月度或季度
            pageSizes: [10, 20, 50, 100, 200],
            pageSize: 10,
            pageIndex: 1,
            totalCount: 0,
            loading: true,
            AuditKPIList:[],//KPI审核列表
            monthList:[
                {id:1,name:'1月'},
                {id:2,name:'2月'},
                {id:3,name:'3月'},
                {id:4,name:'4月'},
                {id:5,name:'5月'},
                {id:6,name:'6月'},
                {id:7,name:'7月'},
                {id:8,name:'8月'},
                {id:9,name:'9月'},
                {id:10,name:'10月'},
                {id:11,name:'11月'},
                {id:12,name:'12月'},
            ],//月份数据
            dialagTitle:'',//弹出框标题
            dialogVisible:false,//是否显示弹框
            becauseOf:'',//驳回原因
            kpiinfo:{},//当前操作KPI信息
            status:'',//当前驳回操作人
        }
    },
    created() {
        //获取当前用户
        this.getCurrentUser();
        //获取当前用户角色
        this.getCurrentRole();
        //获取数据列表
        this.getAuditKPIList();
    },
    methods: {
        //获取当前用户
        getCurrentUser:function(){
            var userinfo = window.sessionStorage.getItem("userinfo");
            userinfo = JSON.parse(Decrypt(userinfo));
            this.currentUser = userinfo;
        },
        //获取当前用户角色
        getCurrentRole:function(){
            var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
            this.currentRole = JSON.parse(Decrypt(currentUserRole));

            console.log('this.currentRole',this.currentRole);
        },
        //条件搜索
        SearchByName:function(){
            this.pageIndex=1;
            this.getAuditKPIList();
        },
        Refresh:function(){
            this.getAuditKPIList();
        },
        //选择周期类型
        selectKPIType:function(event, item){
            if(event==0){
                //显示月度
                this.KPITypeValue=0;
            }else if(event==1){
                //显示季度
                this.KPITypeValue=1;
            }
            else{
                //全部隐藏
                this.KPITypeValue=''
            }
        },
        //获取KPI审核列表数据
        getAuditKPIList:function(){
            this.loading=true;
            AuditkpiList(this.currentRole.Key,this.KPITypeValue,this.PeriodMonth,this.PeriodJ,this.AddName,this.StatusJ,this.ResultStatus,this.pageIndex,this.pageSize).then(res => {
                if(res.totalCount<=0){
                    this.$message({
                        message: '暂无数据',
                        type: 'success'
                    });

                    return false;
                }
                this.loading=false;
                this.totalCount=res.TotalCount;
                this.AuditKPIList=res.List;
            });
        },
        //分页条件搜索
        handleSizeChange(val) {
            this.pageSize = val;
            this.getAuditKPIList();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.getAuditKPIList();
        },
        //查看KPI
        bindKPI:function(kpiModel){
            // var date=new Date();
            // var year=date.getFullYear();
            // var month=date.getMonth();
            // if(month==0){
            //     month=12;
            // }
            // if(month==12||month=='Q4'){
            //     //如果上个月是12月，则年份减1为上个月
            //     year=year-1;
            // }
            var nowTime = new Date(kpiModel.CreateTime);
            this.$router.push('/KPI/BindAuditKPI?frameid='+kpiModel.MainDeptsID+'&thisperiod='+kpiModel.Period+'&kpitype='+kpiModel.KpiType+'&years='+nowTime.getFullYear());
        },
        formatDate(row) {
            var startTime = new Date(row.CreateTime);
            console.log("row=",row);
            return startTime.getFullYear();
      },
        //查看KPI设置
        bindKPISet:function(kpiModel){
            this.$router.push('/KPI/BindAuditKPISet?infoId='+kpiModel.Id+'&frameid='+kpiModel.MainDeptsID);
        },
        //CEO驳回
        initEditStatus:function(item,status){
            this.dialagTitle="请输入驳回原因";
            this.becauseOf="";
            this.dialogVisible=true;
            this.kpiinfo=item;
            this.status=status;
        },
        //计划或结果驳回
        initEditKpi:function(item,status){
            this.dialagTitle="请输入驳回原因";
            this.becauseOf="";
            this.dialogVisible=true;
            this.kpiinfo=item;
            this.status=status;
        },
        //计划完成
        initEditKpiInfo:function(item,status){
            console.log('item',item);
            UpdateKPIStatus(item.Id,this.currentUser.UserCode,1,0,"").then(res=>{
                if(res.Result==1){
                    this.getAuditKPIList();
                }
                else{
                    this.$message.error(res.Message);
                }
            });
        },
        //结果完成
        initEditResult:function(item,status){
            UpdateKPIStatus(item.Id,this.currentUser.UserCode,1,1,"").then(res=>{
                if(res.Result==1){
                    this.getAuditKPIList();
                }
                else{
                    this.$message.error(res.Message);
                }
            });
        },
        //驳回提交
        tijiao:function(){
            if(this.status==-1){
                //CEO驳回
                UpdateStatus(this.kpiinfo.Id,this.currentUser.UserId,this.currentUser.UserCode,this.becauseOf).then(res=>{
                    if(res.Result==1){
                        this.dialogVisible=false;
                        this.getAuditKPIList();
                    }
                    else{
                        this.$message.error(res.Message);
                    }
                });
            }
            else if(this.status==0){
                //计划驳回
                UpdateKPIStatus(this.kpiinfo.Id,this.currentUser.UserCode,0,0,this.becauseOf).then(res=>{
                    if(res.Result==1){
                        this.dialogVisible=false;
                        this.getAuditKPIList();
                    }
                    else{
                        this.$message.error(res.Message);
                    }
                });
            }
            else if(this.status==1){
                //驳回结果
                UpdateKPIStatus(this.kpiinfo.Id,this.currentUser.UserCode,0,1,this.becauseOf).then(res=>{
                    if(res.Result==1){
                        this.dialogVisible=false;
                        this.getAuditKPIList();
                    }
                    else{
                        this.$message.error(res.Message);
                    }
                });
            }
        },
        //KPI设置消息全员发送
        SendMessage:function(){
            SendMessage(this.currentUser.TrueName).then(res=>{
                if(res.Result==1){
                    this.$message({
                        message: '发送成功',
                        type: "success",
                        center: true
                    });
                }else{
                    this.$message({
                        message: '发送失败',
                        type: "danger",
                        center: true
                    });
                }
            })
        }
    },
}
</script>
<style lang="less" scoped>
.show{
    display: block;
}
.hidden{
    display: none;;
}
</style>